import React from 'react';
import { QueryKeys } from '../../api/config';
import { useStaticQuery } from '../../api/queries/use-static-query';
import { AvoidanceZone, type DeviceLocation } from '../../types';
import { MapPlaceholder } from '../drafts-loads/loads/edit-create-order/map-placeholder';
import { HereMapRefObject } from './here-map';
import { HereMapRoute } from './here-map-route';
import { useHereMapBaseContent } from './useHereMapBaseContent';

interface HereMapResourceLogContentProps {
    mapRef: React.RefObject<HereMapRefObject>;
    deviceLocations?: DeviceLocation[];
    trailerDeviceLocations?: DeviceLocation[];
}

export const HereMapResourceLogContent: React.FC<HereMapResourceLogContentProps> = (props) => {
    const { mapRef, deviceLocations, trailerDeviceLocations } = props;
    const { data: avoidanceZones = [], isLoading: isLoadingAvoidanceZones } = useStaticQuery<AvoidanceZone[]>(QueryKeys.avoidanceZones);
    const { deviceHeadings, mappedDeviceLocations, trailerHeadings, mappedTrailerLocations, avoidanceZoneBoxes} = useHereMapBaseContent({deviceLocations, trailerDeviceLocations, avoidanceZones});

    if (mappedDeviceLocations?.length > 0 && !isLoadingAvoidanceZones) {
        return (
            <>
                {deviceHeadings}
                {mappedDeviceLocations.length > 1 &&
                    <HereMapRoute
                        calculateRouteFromWaypoints={false}
                        waypoints={mappedDeviceLocations}
                        onRouteDrawn={() => {
                            mapRef.current?.fitMapToAllObjects(true, undefined, false);
                        }}
                    />
                }
                {trailerHeadings}
                {mappedTrailerLocations.length > 1 &&
                    <HereMapRoute
                        calculateRouteFromWaypoints={false}
                        green={true}
                        waypoints={mappedTrailerLocations}
                    />
                }
                {avoidanceZoneBoxes}
            </>
        );
    } else {
        return <MapPlaceholder isResourceLog={true} />
    }
}